import { hasOpenCurrentTurn, turnsSinceLastUserTurn, type OpenTurnRow } from "@common/utils/open-turn";
import { parseRunningLiveReview } from "@common/schemas/live-review";

export interface ConversationWorkCandidate extends OpenTurnRow {
  content?: string | null;
  toolName?: string;
}

function isRunningLiveReviewMessage(message: ConversationWorkCandidate): boolean {
  return parseRunningLiveReview(message) !== null;
}

export function conversationHasWorkInFlight(messages: ConversationWorkCandidate[]): boolean {
  const currentTurnRows = turnsSinceLastUserTurn(messages);
  return hasOpenCurrentTurn(currentTurnRows) || currentTurnRows.some(isRunningLiveReviewMessage);
}
